import { render } from "./liquid_currency_dropdown.vue?vue&type=template&id=b0d40bf6"
import script from "./liquid_currency_dropdown.vue?vue&type=script&lang=js"
export * from "./liquid_currency_dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__